import React from "react";

const DefaultPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>Welcome to the PSO iForm EPIC Portal</h1>
        <p style={styles.description}>
          This portal showcases the <strong>Save & Resume</strong> functionality.
        </p>
        <p style={styles.instruction}>
          <span style={styles.highlight}>To begin the demonstration:</span>  
          Enter the URL in this format:
        </p>
        <p style={styles.url}>epic.dcs.daylight.io/<b>{"{organization}/{team}/{slug}"}</b></p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f4f4f9",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "600px",
  },
  heading: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "10px",
  },
  description: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "20px",
  },
  instruction: {
    fontSize: "16px",
    color: "#444",
    marginBottom: "10px",
  },
  highlight: {
    fontWeight: "bold",
    color: "#007BFF",
  },
  url: {
    fontSize: "16px",
    backgroundColor: "#eef2ff",
    padding: "10px",
    borderRadius: "4px",
    fontFamily: "monospace",
  },
};

export default DefaultPage;
